export default {
  index: () => import(/* webpackPrefetch: true */ './index.vue')
}